import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutAction } from "../../store/actions/auth.action";
import { ERoutes } from "../../enums/openingSideBar.routes";
import "./header.css";
import { GiFuelTank, GiGasPump } from "react-icons/gi";

const OpeningSideBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const [open, setOpen] = useState(true);

  const logout = () => {
    dispatch(logoutAction());
    navigate("/");
  };
  return (
    <div
      className={` ${
        open ? "w-64" : "w-20 "
      }  h-screen p-5 navClass  pt-8  relative duration-300  `}
    >
      <img
        src="./assets/control.png"
        alt=""
        className={`absolute arrow cursor-pointer -right-3 top-9 w-7 
       border-2 rounded-full  ${!open && "rotate-180"}`}
        onClick={() => setOpen(!open)}
      />
      <Link to="/mainScreen">
        <div className="flex gap-x-4 items-center">
          <img
            src="./assets/logo.png"
            alt=""
            className={`cursor-pointer duration-500 ${
              open && "rotate-[360deg]"
            }`}
          />
          <h1
            className={`text-white origin-left logoHeading font-medium text-xl duration-200 ${
              !open && "scale-0"
            }`}
          >
            IT WORLD
            {/* IT W<span class="braces">&#123;&#125;</span>RLD */}
          </h1>
        </div>
      </Link>
      <ul className="pt-4">
        <Link to="/itemForm">
          <li
            className={`flex ${
              pathname === ERoutes.ITEM ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Meters.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Item
            </span>
          </li>
        </Link>
        <Link to="/party">
          <li
            className={`flex ${
              pathname === ERoutes.PARTY ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/fuel.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Party Account
            </span>
          </li>
        </Link>
        <Link to="/chartOfAccount">
          <li
            className={`flex ${
              pathname === ERoutes.CHART_OF_ACCOUNT ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Purchase.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left  duration-200`}>
              c. Account
            </span>
          </li>
        </Link>
        <Link to="/lubeSale">
          <li
            className={`flex ${
              pathname === ERoutes.MANUAL_GAIN_LOSS ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Lubes.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              M Tank G/L
            </span>
          </li>
        </Link>
        <Link to="/openingStock">
          <li
            className={`flex ${
              pathname === ERoutes.OPENING_STOCK ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase  text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/creditCard.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Stock Opening
            </span>
          </li>
        </Link>
        <Link to="/openingBalGl">
          <li
            className={`flex ${
              pathname === ERoutes.OPENING_GL ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              GL Opening
            </span>
          </li>
        </Link>
        <Link to="/nozel">
          <li
            className={`flex ${
              pathname === ERoutes.NOZEL ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <GiGasPump className="icon" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Nozels
            </span>
          </li>
        </Link>
        <Link to="/tank">
          <li
            className={`flex ${
              pathname === ERoutes.TANK ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <GiFuelTank className="icon" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              tanks
            </span>
          </li>
        </Link>
        {/* <Link to="/tankLorry">
          <li
            className={`flex ${
              pathname === ERoutes.TANK_LORRY ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Tank lorry
            </span>
          </li>
        </Link> */}
          <Link to="/purchaseadv">
          <li
            className={`flex ${
              pathname === ERoutes.PURCHASE_ADV ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Stock Order
            </span>
          </li>
        </Link>
        <Link to="/coupon">
          <li
            className={`flex ${
              pathname === ERoutes.COUPON ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              reg. coupon
            </span>
          </li>
        </Link>
        <Link to="/alert">
          <li
            className={`flex ${
              pathname === ERoutes.ALERT ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Alert
            </span>
          </li>
        </Link>
        <Link to="/rateGL">
          <li
            className={`flex ${
              pathname === ERoutes.RATE_GL ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Rate G/L
            </span>
          </li>
        </Link>
        <Link to="/specialRate">
          <li
            className={`flex ${
              pathname === ERoutes.SPECIAL_RATE ? "bg-blue-500" : ""
            } rounded-md p-2 cursor-pointer hover:bg-blue-500 uppercase text-white text-sm items-center gap-x-4 
           mb-1`}
          >
            <img src={`./assets/Cards.png`} alt="" />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              Special Rate
            </span>
          </li>
        </Link>
      </ul>
      <li
        onClick={logout}
        className={`flex  rounded-md p-2 cursor-pointer hover:bg-blue-500 text-white text-sm items-center gap-x-4 `}
      >
        <img src={`./assets/Logout.png`} alt="" />
        <span className={`${!open && "hidden"} origin-left duration-200`}>
          Logout
        </span>
      </li>
    </div>
  );
};

export default OpeningSideBar;
